import { render, staticRenderFns } from "./CmBenefits.vue?vue&type=template&id=78357e82"
import script from "./CmBenefits.vue?vue&type=script&lang=ts"
export * from "./CmBenefits.vue?vue&type=script&lang=ts"
import style0 from "./CmBenefits.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default,BenefitItem: require('/app/components/base/BenefitItem/BenefitItem.vue').default})
